import { render } from "./AgendaList.vue?vue&type=template&id=1d2e2cc9&scoped=true"
import script from "./AgendaList.vue?vue&type=script&lang=js"
export * from "./AgendaList.vue?vue&type=script&lang=js"

import "./AgendaList.vue?vue&type=style&index=0&id=1d2e2cc9&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2e2cc9"]])

export default __exports__